import React, { useState, useEffect } from "react";
import UploadDocuments from "../../components/documentUploadModal/documentsUploader";
import ApiClient from "../../utils/api-client";
import { useDispatch, useSelector } from "react-redux";
import EuiTile from "../../eui-components/tile";
import PageHelper from "../../utils/page-helper";
import EuiLoading from "../../eui-components/loading";
import ObseleteEuiTable from "../../eui-components/obseleteTable";
import EuiRow from "../../eui-components/row";
import EuiProgressBar from "../../eui-components/progressbar";
import { Notification } from '@eds/vanilla';
import constants from "../../utils/constants";
//import _ from "lodash";
import DialogModal from "../../components/dialog";
import DateUtils from "../../utils/date-utils";
import SasHelper from "../../utils/sas-helper";

const ActivityDocuments = (props) => {
    const userData = useSelector(state => state.user);
    const [openDialog, setOpenDialog] = useState(false);
    const Activity = useSelector(state => state.activity.activity)
    const [activityDocumentsList, setActivityDocumentsList] = useState([]);
    const [percentageArr, setPercentageArray] = useState([]);
    const [openDiaolgUploadBar, setOpenDialogUploadBar] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const files = useSelector(state => state.documents.activityDocuments);
    const [editMod, setEditMod] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [editTitle, setEditedTitle] = useState("");
    const [editType, setEditedType] = useState(null);
    const [warning, setOpenWarning] = useState(false);
    const [removedItem, setDeletedItem] = useState(null);
    const [SASToken, setSASToken] = useState();
    const documentTypes = constants.cmsDocumentTypes;
    const dispatch = useDispatch();
    let documentsIntialList = []
    const documentsColumns = [
        {
            title: "Name",
            key: "documentNameId",
            width: "30%",
            sort: "none",
            hideFilter: editMod ? true : false,
            onCreatedCell: (td, cellData) => {
                if (cellData) {
                    var docId = cellData.split("-@-")[1]
                    var document = activityDocumentsList.find(doc => doc.id == docId);
                    const cellDataName = document.title;
                    const cellDataLink = document.documentPath;
                    if (editMod && document && document.edit && (document.editId == docId)) {
                        let documentName = "";
                        if (editTitle) {
                            documentName = editTitle;
                        }
                        else {
                            documentName = document.title
                        }
                        td.innerHTML = `<span><input style = "width: 90%;" type="text" id="update_" value="${documentName}" ></input>`;
                        td.querySelector("#update_").addEventListener('change', (e) => update(e, "title"));
                    }
                    else {
                        td.innerHTML = `<a id="link_"> ${cellDataName}</a>`;
                        td.querySelector("#link_").addEventListener('click', () => window.open(SasHelper.addSasKey(cellDataLink, SASToken), "_blank"));
                    }
                }
            },
        },
        {
            title: "Document Type",
            key: "documentTypeId",
            sort: "none",
            width: "20%",
            hideFilter: editMod ? true : false,
            onCreatedCell: (td, cellData) => {
                if (cellData) {
                    var docId = cellData.substring(0, cellData.indexOf("@"))
                    var document = activityDocumentsList.find(doc => doc.id == docId);
                    if (editMod && document && document.edit && (document.editId == docId)) {
                        var selectedItem = "";
                        var optionsList = "";
                        var option = "";
                        var value = "";
                        (editType != null) ? value = editType : value = document.documentTypeName;
                        documentTypes.map(item => {
                            if (item.text.trim() === value.trim()) {
                                selectedItem = item.text;
                                option = `<option value="${selectedItem}" selected>${item.text}</option>`
                            }
                            else {
                                option = `<option value="${item.text}">${item.text}</option>`
                            }
                            optionsList += option
                        })
                        td.innerHTML = `<span><select style = "width: 200px; font-height: 400px; border: 1px solid #878787; line-height: 1.5; padding: 5px 7px 4px; margin-right: 8px; font-weight: 400; font-size: 14px; background: #fff; color: #242424; font-family: Ericsson Hilda; name="selectDialog" id="update_" value="${selectedItem}"> ${optionsList}</select>`;
                        td.querySelector("#update_").addEventListener('change', (e) => update(e, "type"));

                    }
                    else {
                        td.innerHTML = PageHelper.mapDocumentTypes(document.documentType);
                    }
                }
            }
        },
        {
            title: "Last Modified Date",
            key: "lastModifiedDate",
            width: "15%",
            sort: 'none',
            hideFilter: editMod ? true : false,
            onCreatedCell: (td, cellData) => {
                td.innerHTML = DateUtils.toDateString(cellData, "YYYY-MM-DD HH:mm")
            }
        },
        {
            title: "Last Modified User",
            key: "lastModifiedUser",
            sort: "none",
            width: "15%",
            hideFilter: editMod ? true : false,
        },
        {
            title: "",
            key: "editId",
            width: "2%",
            hideFilter: true,
            onCreatedCell: (td, cellData) => {
                if (cellData) {
                    var document = activityDocumentsList.find(doc => doc.id == cellData);
                    if (editMod && cellData == document.id && (document.editId == cellData)) {
                        td.innerHTML = `<span id="save_" class="tooltip"><i id="save_" class="icon icon-check text-lg clickable color-green "></i><span class="message top-end">Save</span></span>`;
                        td.querySelector("#save_").addEventListener('click', () => save(cellData));
                    }
                    else {
                        td.innerHTML = `<span  id="edit_" class="tooltip"><i id="edit_" style={font-weight:500px;} class="icon icon-edit color-black  text-lg clickable "></i><span class="message top-end">Edit</span></span>`;
                        td.querySelector("#edit_").addEventListener('click', () => setEditMode(cellData))
                    }
                }
            }
        },
        {
            title: "",
            key: "deleteId",
            width: "2%",
            hideFilter: true,
            onCreatedCell: (td, cellData) => {
                if (cellData) {
                    var document = activityDocumentsList.find(doc => doc.id == cellData);
                    if (editMod && cellData === document.id && (document.editId == cellData)) {
                        td.innerHTML = `<span id="cancel_" class="tooltip"><i id="cancel_"  class="icon icon-cross  text-lg clickable color-red "></i><span class="message top-end">Cancel</span></span>`
                        td.querySelector("#cancel_").addEventListener('click', () => cancel(cellData));
                    }
                    else {
                        td.innerHTML = `<span id="delete_" class="tooltip"><i id="delete_" style={font-weight:500px;} class="icon icon-trashcan color-black  text-lg clickable "></i><span class="message top-end">Delete Document</span></span>`;
                        td.querySelector("#delete_").addEventListener('click', () => confirmDelete(cellData));
                    }

                }
            }
        }
    ];

    useEffect(() => {
        if (activityDocumentsList.length === 0) {
            ApiClient.post("Workplan/GetDocumentsBySystemId", { systemId: parseInt(Activity.id), objectTypeId: 5 }).then(response => {
                setIsLoading(false);
                setSASToken(response.data.sasToken);
                var sortedArray = sortByKey(response.data.data, "updatedAt");
                setActivityDocumentsList(sortedArray);
            }).catch(error => console.error(error))
        }
        if (openDiaolgUploadBar) {
            const onProgress = createPercentage;
            PageHelper.uploadItems(files, onProgress, "activity-documents").then(uploadedFiles => {
                const notification = new Notification({
                    title: 'Document is uploaded successfully!',
                    timeout: 5000,
                    icon: 'icon-check'
                });
                notification.init();
                setOpenDialogUploadBar(false);
                documentsIntialList = uploadedFiles;
                setIsLoading(true)
                addDocuments();
            })
        }
        if (confirm == true) {
            softDeleteDocument();
            setConfirm(false);
            setOpenWarning(false);
        }
    }, [openDiaolgUploadBar, isLoading, confirm]);

    const confirmDelete = (data) => {
        setOpenWarning(true);
        setDeletedItem(data);
    }

    const sortByKey = (array, key) => {
        return array.sort(function (a, b) {
            var x = a[key];
            var y = b[key];

            if (typeof x == "string") {
                x = ("" + x).toLowerCase();
            }
            if (typeof y == "string") {
                y = ("" + y).toLowerCase();
            }

            return ((x < y) ? 1 : ((x > y) ? -1 : 0));
        });
    }

    const createPercentage = (progressEvent, file) => {
        let percentage = Math.floor((progressEvent.loadedBytes * 100) / file.size);
        let percentageArray = [...percentageArr];
        const index = percentageArray.indexOf(file);
        percentageArray[index].percentage = percentage;
        setPercentageArray(percentageArray);
    }

    const addDocuments = () => {
        if (!documentsIntialList || documentsIntialList.length == 0) {
            const notification = new Notification({
                title: 'Upload Failed',
                description: 'No selected files to be uploaded!',
                timeout: 5000,
                icon: 'icon-check'
            });
            notification.init();
            return;
        }
        const docs = documentsIntialList.map(item => {
            return {
                title: item.title,
                documentPath: item.documentPath,
                systemId: parseInt(Activity.id),
                documentType: parseInt(item.documentType),
                objectTypeId: 5,
                lastModifiedUser: parseInt(userData.userData.userId)
            }
        });
        ApiClient.post("Workplan/AddDocuments", docs)
            .then(response => {
                ApiClient.post("Workplan/GetDocumentsBySystemId", { systemId: parseInt(Activity.id), objectTypeId: 5 }).then(response => {
                    setIsLoading(false);
                    setSASToken(response.data.sasToken)
                    var sortedArray = sortByKey(response.data.data, "updatedAt");
                    setActivityDocumentsList(sortedArray);
                    dispatch({ type: "SET_ACTIVITY_DOCUMENTS", payload: [] });
                }).catch(error => console.error(error))
            }).catch(error => {
                console.error(error.response.data);
                setIsLoading(false);
            });
    }

    const uploadDocuments = () => {
        var flag = false;
        const fileSize = PageHelper.checkFilesSize(files);
        if (fileSize) {
            const notification = new Notification({
                title: 'Upload Failed',
                description: fileSize,
                timeout: 5000,
                icon: 'icon-triangle-warning'
            });
            notification.init();
            return;
        }
        else {
            files.map(item => {
                if (item.documentType == null) {
                    flag = true;
                }
            });
            if (flag) {
                const notification = new Notification({
                    title: 'Upload Failed',
                    description: 'Please add all document types!',
                    timeout: 5000,
                    icon: 'icon-triangle-warning'
                });
                notification.init();
                return;
            }
            else {
                PageHelper.getCoordinates();
                setOpenDialog(false);
                setOpenDialogUploadBar(true);
                setPercentageArray(PageHelper.initializePercentageArr(files))
            }
        }
    }

    const softDeleteDocument = () => {
        if (confirm === true) {
            const deletedItem = activityDocumentsList.find(item => item.id == removedItem);
            deletedItem['delete'] = true;
            deletedItem['lastModifiedUser'] = parseInt(userData.userData.userId);
            ApiClient.post("Workplan/UpdateWorkplanDocument", deletedItem).then(response => {
                const notification = new Notification({
                    title: 'Document is deleted successfully!',
                    timeout: 5000,
                    icon: 'icon-check'
                });
                notification.init();
                setIsLoading(true);
                ApiClient.post("Workplan/GetDocumentsBySystemId", { systemId: parseInt(Activity.id), objectTypeId: 5 }).then(response => {
                    setIsLoading(false);
                    setSASToken(response.data.sasToken)
                    var sortedArray = sortByKey(response.data.data, "updatedAt");
                    setActivityDocumentsList(sortedArray);
                    setDeletedItem(null);
                });
            }).catch(err => {
                const notification = new Notification({
                    title: 'An issue occurred while deleting the document, please try again!',
                    timeout: 5000,
                    icon: 'icon-triangle-warning'
                });
                notification.init();
                setOpenWarning(false);
                setConfirm(false);
                setDeletedItem(null);
            }
            );
        }

    }

    const setEditMode = (data) => {
        const updatedArray = []
        if (editMod === false) {
            activityDocumentsList.map(item => {
                if (item.id == data) {
                    item["edit"] = true;
                    item["editId"] = item.id;
                    item["documentTypeName"] = PageHelper.mapDocumentTypes(item.documentType);
                }
                updatedArray.push(item);
            });
            setActivityDocumentsList(updatedArray);
            setEditMod(true);
            setEditedTitle("");
            setEditedType(null);
        }
    }

    const update = (e, object) => {
        if (object === "title") {
            setEditedTitle(e.target.value)
        }
        else if (object === "type") {
            setEditedType(e.target.value);
        }
    }

    const cancel = (data) => {
        var updatedArray = []
        activityDocumentsList.map(item => {
            if (item.id == data) {
                item["edit"] = false;
                item["editId"] = 0;
            }
            updatedArray.push(item);
        });
        setActivityDocumentsList(updatedArray);
        setEditMod(false);
    }

    const save = (data) => {
        const updatedArray = []
        var document = activityDocumentsList.find(doc => doc.id == data);
        if (editTitle.length != 0 && editType != null) {
            document.title = editTitle;
            document.documentType = constants.cmsDocumentTypes.find(x => x.text == editType).value;
        }
        else if (editType != null) {
            document.documentType = constants.cmsDocumentTypes.find(x => x.text == editType).value;
        }
        else if (editTitle.length > 0) {
            document.title = editTitle;
        }
        document.lastModifiedUser = parseInt(userData.userData.userId);
        setIsLoading(true);
        ApiClient.post("Workplan/UpdateWorkplanDocument", document).then(response => {
            const notification = new Notification({
                title: 'Document is updated successfully!',
                timeout: 5000,
                icon: 'icon-check'
            });
            notification.init();
            ApiClient.post("Workplan/GetDocumentsBySystemId", { systemId: parseInt(Activity.id), objectTypeId: 5 }).then(response => {
                setIsLoading(false);
                setSASToken(response.data.sasToken)
                var sortedArray = sortByKey(response.data.data, "updatedAt");
                sortedArray.map(item => {
                    if (item.id == data) {
                        item["edit"] = false;
                        item["editId"] = 0;
                    }
                    updatedArray.push(item);
                });
                setActivityDocumentsList(updatedArray);
                setEditMod(false);
                setEditedTitle("");
                setEditedType(null);
            }).catch(err => console.error(err));
        }).catch(err => console.error(err));

    }

    const viewActivityDocuments = () => {
        let dataItems = [];
        dataItems = activityDocumentsList.map(item => {
            return {
                id: item.id,
                documentTypeId: item.id + "@" + PageHelper.mapDocumentTypes(item.documentType),
                documentNameId: item.title + "-@-" + item.id,
                name: [item.title, item.documentPath],
                type: item.documentType,
                lastModifiedDate: item.updatedAt,
                lastModifiedUser: item.lastModifiedUserName,
                editId: item.id,
                deleteId: item.id,
            }
        })
        return <EuiRow style={{ padding: '10px' }}>
            <ObseleteEuiTable
                classes="tiny"
                style={{ overflow: 'hidden' }}
                columns={documentsColumns}
                data={dataItems}
                id={"activityDocumentsTable"}
                styleHeader={{ width: "100%" }}
                styleTd={{ width: "100%" }}
                scroll={false}
                key={activityDocumentsList + editMod + editTitle + editType}
                sortable={true}
                paginated={true}
                rowsPerPage={10}
                filter={true}
            /></EuiRow>
    }
    return (
        <EuiTile fullscreen tileStyle={{ padding: 0 }} className={isLoading ? " disabled " : ""} key={isLoading} >
            <EuiRow>
                <EuiLoading id="activityDocumentsLoading" isLoading={isLoading} />
                <div className="flex-end-content w-10">
                    <button style={{ float: "right", margin: "10px" }} className="btn primary m-1 " onClick={() => setOpenDialog(true)}>
                        <i className="icon icon-file-add p-1" />Upload Document</button></div>
                <EuiRow>
                    {(Object.values(activityDocumentsList).length != 0) ? viewActivityDocuments() : <div className="flex-middle-content m-2 w-10" style={{ fontSize: "18px", color: "gray" }}>No documents attached to this activity</div>}
                </EuiRow>
                <DialogModal
                    buttonName="Delete"
                    type="warning"
                    title={"Delete Document"}
                    content="Are you sure you want to delete this document?"
                    handleClose={() => setOpenWarning(false)}
                    mainButtonStyle={{ backgroundColor: "red" }}
                    id="alertDialog"
                    onClick={() => setConfirm(true)}
                    open={warning}
                    style={{ width: "380px", height: "50%" }}
                    contentStyle={{ width: "380px" }}
                    disableBackdropClick={true}
                />
                <DialogModal
                    content={percentageArr.map(file => {
                        return <div key={file.name} style={{ width: 500 }}>
                            <label><strong>{file.title}</strong></label>
                            <EuiProgressBar value={file.percentage} />
                        </div>
                    })}
                    handleClose={() => setOpenDialogUploadBar(false)}
                    id="uploadActivityDocumentsDialog"
                    titleId="titleuploadBarActivityDocumentsUploadDialog"
                    open={openDiaolgUploadBar}
                    buttonsVisible="false"
                    title="Progress Loading..."
                    closeButtonVisible="false"
                    key={percentageArr}
                    disableBackdropClick={true}
                >
                </DialogModal>
                <DialogModal
                    id="activityDocumentsDialog"
                    style={{ height: "1000px" }}
                    title="Add Documents"
                    content={<UploadDocuments id="activityDocumentsDialog" dispatch="SET_ACTIVITY_DOCUMENTS" columns={{ name: true, type: true }} />}
                    buttonName="Upload"
                    handleClose={() => setOpenDialog(false)}
                    onClick={() => uploadDocuments()}
                    contentStyle={{ width: "800px", height: "400px" }}
                    open={openDialog}
                    disableBackdropClick={true}
                />
            </EuiRow>
        </EuiTile>
    );
}
export default ActivityDocuments;